export default "__VITE_ASSET__CDtVVHnF__"